// extracted by mini-css-extract-plugin
export default {"layout":"styles_layout__+cyZW","container":"styles_container__odx3d"};